<template>
  <a-modal :title="title" :width="1100" :visible="visible" :confirmLoading="confirmLoading" @ok="handleOk"
    @cancel="handleCancel" :cancelText="$t('close')">
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="$t('productName')">
          <a-input :placeholder="$t('productName')" v-decorator="['productName', validatorRules.productName]" />
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="$t('productType')">
          <a-select showSearch v-decorator="['appssid', validatorRules.appssid]">
            <a-select-option v-for="item in appList" :key="item.appssid">
              {{ item.appName }}
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="$t('receiptMode')">
          <a-select v-decorator="['receiptTimeFlag', validatorRules.receiptTimeFlag]">
            <a-select-option :key="'0'">{{ $t('preCollected') }}</a-select-option>
            <a-select-option :key="'1'">{{ $t('postCollected') }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="$t('status')">
          <a-select v-decorator="['status', validatorRules.status]">
            <a-select-option :key="'0'">{{ $t('invalid') }}</a-select-option>
            <a-select-option :key="'1'">{{ $t('valid') }}</a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import pick from 'lodash/pick'
import { addProduct, editProduct } from '@/webpublicapi/installmentProductManager'
import { getApplist } from '@/webpublicapi/order'
// duplicateCheck
export default {
  name: 'installmentProductModal',

  data() {
    return {
      value: 1,
      title: this.$t('action'),
      type: '0',
      allowPrepay: 1,
      productId: '',
      visibleCheck: true,
      visible: false,
      model: {},
      appList: [],
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      form: this.$form.createForm(this),
    }
  },
  computed: {
    validatorRules() {
      return {
        productName: { rules: [{ required: true, message: this.$t('inputProductName') }] },
        receiptTimeFlag: { rules: [{ required: true, message: this.$t('selectReceiptMode') }] },
        status: { rules: [{ required: true, message: this.$t('selectStatus') }] },
        appssid: { rules: [{ required: true, message: this.$t('selectProductType') }] },
      }
    }
  },
  created() { },
  methods: {
    add(params) {
      this.edit({ type: params.type })
    },
    edit(record) {
      this.type = record.type
      getApplist().then((res) => {
        this.appList = res.data || []
      })
      this.form.resetFields()
      this.model = Object.assign({}, record)
      if (record.id) {
        this.allowPrepay = record.allowPrepay
        this.visibleCheck = record.allowPrepay == 1
      }
      this.visible = true
      const data = pick(this.model, 'productName', 'appssid', 'receiptTimeFlag', 'status', 'type')
      data.allowPrepay = !!data.allowPrepay
      this.$nextTick(() => {
        this.form.setFieldsValue(data)
      })
    },
    onChose(checked) {
      if (checked) {
        this.allowPrepay = 1
        this.visibleCheck = true
      } else {
        this.allowPrepay = 0
        this.visibleCheck = false
      }
    },
    // Confirm
    handleOk() {
      const that = this
      // Trigger form validation
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true
          const formData = Object.assign(this.model, values)
          formData.allowPrepay = +formData.allowPrepay ? 1 : 0
          formData.type = that.type
          let obj
          if (!that.model.id) {
            formData.productId = this.productId
            obj = addProduct(formData)
          } else {
            obj = editProduct(formData)
          }
          obj
            .then((res) => {
              if (res.code === 1000) {
                that.$message.success(res.msg)
                that.$emit('ok')
              } else {
                that.$message.warning(res.msg)
              }
            })
            .finally(() => {
              that.confirmLoading = false
              that.close()
            })
        }
      })
    },
    // Close
    handleCancel() {
      this.close()
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
  },
}
</script>
